import type { ThemeComponentStyle } from '@unifyapps/defs/theme/types';

/**
 * concatenates compiledOutput from all component style configs into a single
 * unscoped CSS string. callers must scope the result via
 * scopeComponentStylesForMatrix / scopeComponentStylesForPlatform before injection.
 */
export function getComponentStylesOutput(
  components: Record<string, ThemeComponentStyle> | undefined,
): string {
  if (!components) return '';

  let output = '';
  for (const config of Object.values(components)) {
    if (config.compiledOutput) {
      output += config.compiledOutput;
    }
  }
  return output;
}
